module.exports = __webpack_public_path__ + "img/ons_campaign_1_desc.c9051db8.png";